import React, { createContext, useContext, useState, useEffect } from 'react';
import axios from 'axios';
import { environment } from "../environnements/ennvironnement";

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
    const [user, setUser] = useState(null);

    useEffect(() => {
        // Vérifier si un utilisateur est déjà connecté au chargement
        const storedUser = localStorage.getItem('user');
        if (storedUser) {
            setUser(JSON.parse(storedUser));
        }
    }, []);

    const signIn = async (userData) => {
        console.log({userData});
        
        try{
            // Configuration d'Axios pour la requête des détails utilisateur
            const response = await axios.get(`${environment.backend_url}/ws/api/v1/accounts/user/detail`, {
                headers: {
                    'Authorization': `Bearer ${userData.access}`,
                }
            });

            console.log({response});
            
            if (response.data[0].success === 1 && response.data[0].results.length > 0) {
                const userInfo = response.data[0].results[0];
                
                // Création de l'objet utilisateur complet
                const completeUserData = {
                    ...userInfo,
                    access: userData.access,
                    refresh: userData.refresh,
                };

                // Mise à jour du state et du localStorage
                setUser(completeUserData);
                localStorage.setItem('user', JSON.stringify(completeUserData));
                localStorage.setItem('accessToken', userData.access);
                localStorage.setItem('refreshToken', userData.refresh);
            } else {   
                throw new Error('User not found');
            }
        } catch (error) {
            console.error('An error occurred when retrieveing user data : ', error);
            throw error;
        }
    };

    const signOut = () => {
        setUser(null);
        localStorage.removeItem('user');
        localStorage.removeItem('accessToken');
        localStorage.removeItem('refreshToken');
    };

    return (
        <AuthContext.Provider value={{ user, signIn, signOut }}>
            {children}
        </AuthContext.Provider>
    );
};

export const useAuth = () => useContext(AuthContext);